<template>
  <div>
    <template>
      <el-row>
        <el-col :span="11">
          <el-table :data="urlList"
                    stripe
                    style="width: 100%">
            <el-table-column prop="path"
                             label="url路径"
                             width="180">
            </el-table-column>
            <el-table-column prop="name"
                             label="url名称"
                             width="180">
            </el-table-column>
            <el-table-column label="url类型">
              <template slot-scope="scope">
                {{scope.row.type | typeFilter}}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link :underline="false"
                         @click="form = scope.row">编辑</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="11">
          <el-form ref="form"
                   :model="form"
                   label-width="80px">
            <el-form-item label="URL路径">
              <el-input v-model="form.path"></el-input>
            </el-form-item>
            <el-form-item label="URL名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="接口类型">
              <el-select v-model="form.type"
                         placeholder="">
                <el-option label="雪宁"
                           value="SXN"></el-option>
                <el-option label="保星"
                           value="KBX"></el-option>
                <el-option label="彦东"
                           value="LYD"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary"
                         @click="onSubmit">
                <template v-if="form.id">
                  修改
                </template>
                <template v-else>
                  添加
                </template>
              </el-button>
              <el-button @click="form={}"> 清空</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

    </template>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ele',
  data: function () {
    return {
      activeName: 'url',
      urlStatus: 'TRUE',
      urlList: [],
      form: {}
    }
  },
  filters: {
    typeFilter: function (v) {
      switch (v) {
        case 'SXN':
          return '雪宁'
        case 'LYD':
          return '彦东'
        case 'KBX':
          return '保星'
        default:
          return '未知'
      }
    }
  },

  computed: {

  },
  methods: {
    getList () {
      let _this = this
      axios.get('/api/web/admin/urlList?status=' + this.urlStatus).then(resp => {
        _this.urlList = resp.data
      })
    },
    onSubmit () {
      let _this = this
      axios.post('/api/web/admin/saveUrl', this.form).then(resp => {
        _this.form = {}
        _this.getList()
      })
    }
  },

  mounted () {
    this.getList()
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/app/developer/urls.vue